module.exports = __webpack_public_path__ + "static/3-2aad6ada05ddf1930730b89f9a31dc30.png";